module.exports = __webpack_public_path__ + "img/ETransportShip64_ua.3d1f36a1.webp";